export default "https://cdn-web.disco.co/slack-auto-connect-mobile-1-c5fafb950bd3b58467eda309800a4518.png";